import { GatewayExtendEntity } from '@modules/setting/models/gateway.model';

export interface Gateway extends GatewayExtendEntity {
    id?: string;
    code?: string;
    platform_linked?: string;
    platform_unlink?: string;
    sandbox?: boolean;
    notification_enabled?: boolean;
    notification_amount?: number;
    currency_lookup?: [];
    fee?: number;
    merchant?: string;
}
